<template>
    <div id="information" class="mainContainer bgGray pbottom50">
        <Banner></Banner>
        <div class="info_list_box w11 mtop30">
            <!-- 选项卡 -->
            <div class="info_list_tabs_box">
                <el-tabs v-model="tabsName" @tab-click="handleTabsClick">
                    <el-tab-pane label="通知公告" name="notice"></el-tab-pane>
                    <el-tab-pane label="行业新闻" name="article"></el-tab-pane>
                    <el-tab-pane label="求职信息" name="job"></el-tab-pane>
                </el-tabs>
                <div class="info_list_adress">
                    <img
                        src="~assets/images/information/adressImg.png"
                        alt=""
                    />
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item class="item_now"
                            >信息模块</el-breadcrumb-item
                        >
                    </el-breadcrumb>
                </div>
            </div>
            <!-- 通知公告列表 -->
            <div class="noticeList" v-if="tabsName == 'notice'">
                <div class="info_list_content">
                    <div class="index-info-news-list" v-if="!hasNotice">
                        <el-empty description="暂无通知公告信息"></el-empty>
                    </div>
                    <div v-else>
                        <div
                            class="info_list_item"
                            v-for="noticeItem in noticeList"
                            :key="noticeItem.id"
                            @click="enterNoticeDetail(noticeItem.id)"
                        >
                            <p>{{ noticeItem.title }}</p>
                            <span>{{ noticeItem.updateDate }}</span>
                        </div>
                        <!-- 分页器 -->
                        <div class="block page_box mtb30">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="noticePageObj.size"
                                :background="true"
                                :total="noticePageObj.total"
                                @current-change="noticeCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 行业新闻列表 -->
            <div class="articleList" v-if="tabsName == 'article'">
                <div class="info_list_content">
                    <div class="index-info-news-list" v-if="!hasArticle">
                        <el-empty description="暂无通知公告信息"></el-empty>
                    </div>
                    <div v-else>
                        <div
                            class="info_list_item"
                            v-for="articleItem in articleList"
                            :key="articleItem.id"
                            @click="enterArticleDetail(articleItem.id)"
                        >
                            <p>{{ articleItem.title }}</p>
                            <span>{{ articleItem.updateDate }}</span>
                        </div>
                        <!-- 分页器 -->
                        <div class="block page_box mtb30">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="articlePageObj.size"
                                :background="true"
                                :total="articlePageObj.total"
                                @current-change="articleCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 行业新闻列表 -->
            <div class="articleList" v-if="tabsName == 'job'">
                <div class="info_list_content">
                    <div class="index-info-news-list" v-if="!hasJob">
                        <el-empty description="暂无求职信息"></el-empty>
                    </div>
                    <div v-else>
                        <div
                            class="info_list_item"
                            v-for="jobItem in jobList"
                            :key="jobItem.id"
                        >
                            <p>{{ jobItem.title }}</p>
                            <span>{{ jobItem.updateDate }}</span>
                        </div>
                        <!-- 分页器 -->
                        <div class="block page_box mtb30">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="jobPageObj.size"
                                :background="true"
                                :total="jobPageObj.total"
                                @current-change="jobCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "views/PcViews/Information/Banner";
import { getNoticeList, getArticleList } from "api/article";
export default {
    components: { Banner },
    computed: {
        //是否有通知公告信息
        hasNotice() {
            return this.noticePageObj.total == 0 ? false : true;
        },
        //是否有行业新闻信息
        hasArticle() {
            return this.articlePageObj.total == 0 ? false : true;
        },
        //是否有求职信息
        hasJob() {
            return this.jobPageObj.total == 0 ? false : true;
        },
    },
    data() {
        return {
            //信息类型
            newsType:"",
            //标签页名称 notice -- 通知公告， article -- 行业新闻， jop -- 求职信息
            tabsName: "notice",
            //通知公告分页器
            noticePageObj: {
                page: 1,
                size: 12,
                total: 0,
            },
            //通知公告列表
            noticeList: [],
            //行业新闻、求职信息Tab标
            activeNum: 0,
            //行业新闻分页器
            articlePageObj: {
                page: 1,
                size: 12,
                total: 0,
            },
            //行业新闻列表
            articleList: [],
            jobPageObj: {
                page: 1,
                size: 12,
                total: 0,
            },
            //求职信息列表
            jobList: [],
        };
    },
    created() {
        this.newsType = this.$route.query.newsType;
        this.tabsName = this.$route.query.newsType == undefined ? 'notice' : this.$route.query.newsType;
        if(this.newsType == 'notice' || this.newsType == undefined){
            this.fetchNoticListData(
                this.noticePageObj.page,
                this.noticePageObj.size
            );
        }else if(this.newsType == 'article'){
            this.fetchArticleListData(
                this.articlePageObj.page,
                this.articlePageObj.size
            );
        }
    },
    methods: {
        //进去通知公告详情
        enterNoticeDetail(noticeId) {
            this.$router.push({
                path: "/pcViews/information/notice-detail",
                query: {
                    noticeId,
                },
            });
        },
        //通知公告分页器切换
        noticeCurrentChange(current) {
            //分页数切换
            this.noticePageObj.page = current;
            this.fetchNoticListData(
                this.noticePageObj.page,
                this.noticePageObj.size
            );
        },
        //获取通知公告列表信息
        fetchNoticListData(page, size) {
            getNoticeList(page, size).then((res) => {
                let { success, errorCode, body } = res;
                let { total, rows } = body.data;
                if (success && errorCode == "2000") {
                    this.noticePageObj.total = total;
                    this.noticeList = rows;
                }
            });
        },
        //进去行业新闻详情
        enterArticleDetail(articleId) {
            this.$router.push({
                path: "/pcViews/information/article-detail",
                query: {
                    articleId,
                },
            });
        },
        //行业新闻分页器切换
        articleCurrentChange(current) {
            this.articlePageObj.page = current;
            this.fetchArticleListData(
                this.articlePageObj.page,
                this.articlePageObj.size
            );
        },
        //获取行业新闻列表信息
        fetchArticleListData(page, size) {
            getArticleList(page, size).then((res) => {
                let { success, errorCode, body } = res;
                let { count, list } = body.data;
                if (success && errorCode == "2000") {
                    this.articlePageObj.total = count;
                    this.articleList = list;
                }
            });
        },
        //求职信息分页器切换
        jobCurrentChange(current) {
            console.log(current);
        },
        //标签页切换
        handleTabsClick(tab) {
            this.tabsName = tab.name;
            if (tab.name == "notice") {
                this.noticePageObj.page = 1;
                this.fetchNoticListData(
                    this.noticePageObj.page,
                    this.noticePageObj.size
                );
            } else if (tab.name == "article") {
                this.articlePageObj.page = 1;
                this.fetchArticleListData(
                    this.articlePageObj.page,
                    this.articlePageObj.size
                );
            }
        },
    },
};
</script>

<style>
.info_list_tabs_box .el-tabs__header {
    margin: 0;
}
.info_list_tabs_box .el-tabs__item {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
}
.info_list_tabs_box .el-tabs__item.is-active,
.course_info_tabs .el-tabs__item:hover {
    color: #133d93;
}
.info_list_tabs_box .el-tabs__active-bar {
    background-color: #133d93;
}
</style>

<style lang="less" scoped>
.info_list_item:hover p,
.info_list_item:hover span {
    color: #133d93;
}
.info_list_item:hover {
    border-color: #133d93;
}
.info_list_item span {
    display: block;
    width: 186px;
    text-align: right;
    font-size: 12px;
    color: #a6a6a6;
}
.info_list_item p {
    max-width: calc(100% - 186px);
    font-size: 14px;
    color: #000;
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.info_list_item {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 6px 24px;
    height: 48px;
    border-bottom: dashed 1px #d3d3d3;
    justify-content: space-between;
    cursor: pointer;
}
.info_list_adress img {
    margin-right: 12px;
}
.info_list_adress {
    position: absolute;
    right: 24px;
    top: 16px;
    height: 54px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.info_list_tabs_box {
    padding-top: 20px;
    height: 60px;
    position: relative;
}
.info_list_box {
    padding: 0 20px;
    background: #fff;
    box-shadow: 0px 0px 9px 0px rgba(40, 40, 40, 0.2);
    overflow: hidden;
}
</style>
